import { SHOW_USER_DETAILS } from 'actionTypes/userDetailsActionTypes';

export const setUserDetails = (payload) => ({
  type: SHOW_USER_DETAILS,
  payload,
});
export default {
  setUserDetails,
};
